import { Box } from "@mui/material";
import React from "react";

export interface BackgroundProps {
    children: React.ReactNode;
}

export const Background: React.FC<BackgroundProps> = ({children}) => {
    return (
    <Box
        sx={{
            position: 'relative',
            minHeight: '100vh',
            width: '100%',
            overflow: 'hidden',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
            background: 'linear-gradient(to bottom, #FBE858 0%, #F8DAEE 100%)'
        }}
    >
        {children}
    </Box>)
}